import { Badge } from '@mantine/core';

const LEVEL_CONFIG: Record<string, { color: string; label: string }> = {
  low: { color: 'green', label: '空位充足' },
  medium: { color: 'yellow', label: '尚有空位' },
  high: { color: 'orange', label: '即將額滿' },
  full: { color: 'red', label: '已額滿' },
};

export function BusyBadge({ level }: { level: string }) {
  const cfg = LEVEL_CONFIG[level] ?? { color: 'gray', label: level };
  return (
    <Badge size="lg" color={cfg.color} variant="filled" radius="sm">
      {cfg.label}
    </Badge>
  );
}
